module.exports = __webpack_public_path__ + "static/media/JonasDavidOcampoVazquez.4a8c607f.jpg";